import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { INTERNAL_NAVIGATION_UTM_MEDIUM, UtmParams } from "@vc-workspace/utils-constants";
import { getDisplayImageObj } from "@vc-workspace/utils-helpers";
import { Typography } from "@vc-workspace/utils-typography";
import { useRouter } from "next/router";
import { gridContainer, gridItemContainer, imageContainerStyles, imageStyles } from "./shop-catalogue-bubbles.module.style";
/* eslint-disable-next-line */

export function ShopCatalogueBubbles(props) {
  var router = useRouter();

  function onCatalogueClick(catalogue) {
    var query = {
      utm_medium: ''
    };

    if (props.context.query[UtmParams.UTM_MEDIUM] === INTERNAL_NAVIGATION_UTM_MEDIUM) {
      query.utm_medium = INTERNAL_NAVIGATION_UTM_MEDIUM;
    } else {
      delete query.utm_medium;
    }

    if (!catalogue) {
      router.push({
        pathname: "/".concat(props.shop.slug, "/collection/allproducts"),
        query: query
      });
    } else {
      router.push({
        pathname: "/".concat(props.shop.slug, "/collection/").concat(catalogue.slug),
        query: query
      });
    }
  }

  function onOfferClick(offer) {
    var query = {
      utm_medium: ''
    };

    if (props.context.query[UtmParams.UTM_MEDIUM] === INTERNAL_NAVIGATION_UTM_MEDIUM) {
      query.utm_medium = INTERNAL_NAVIGATION_UTM_MEDIUM;
    } else {
      delete query.utm_medium;
    }

    router.push({
      pathname: "/".concat(props.shop.slug, "/offers/").concat(offer.offerCode),
      query: query
    });
  }

  var firstSIAImage = null;

  if (props.firstSIA && props.firstSIA.itemDetail) {
    firstSIAImage = getDisplayImageObj(props.firstSIA.itemDetail.images[0], "2");
  }

  var visibleCollections = props.context.isMobileView ? 3 : 7;
  var totalVisibileItems = props.catalogues.length + props.offers.length;
  return _jsx("div", {
    children: _jsxs("div", {
      css: gridContainer,
      className: totalVisibileItems > visibleCollections ? "justify-start" : "justify-center",
      children: [props.catalogues.length ? _jsxs("div", {
        css: gridItemContainer,
        onClick: function onClick() {
          return onCatalogueClick();
        },
        children: [_jsx("div", {
          css: imageContainerStyles,
          children: firstSIAImage ? _jsxs("picture", {
            children: [_jsx("source", {
              srcSet: firstSIAImage.webP,
              type: "image/webp"
            }), _jsx("img", {
              src: firstSIAImage.url,
              css: imageStyles,
              alt: "All Products"
            })]
          }) : _jsx("span", {
            css: imageStyles
          })
        }), _jsx(Typography, {
          type: "Body1",
          color: "night_rider",
          className: "text-center whitespace-normal ".concat(props.context.isMobileView ? "pt-2" : "pt-2"),
          semi_bold: true,
          children: "All Products"
        })]
      }) : null, props.offers.map(function (offer) {
        var _offer$v2Details;

        var displayImage = getDisplayImageObj(offer.images && offer.images[0], props.context.isMobileView ? "1" : "2");
        return _jsxs("div", {
          css: gridItemContainer,
          onClick: function onClick() {
            return onOfferClick(offer);
          },
          children: [_jsx("div", {
            css: imageContainerStyles,
            children: displayImage.url ? _jsxs("picture", {
              children: [_jsx("source", {
                srcSet: displayImage.webP,
                type: "image/webp"
              }), _jsx("img", {
                src: displayImage.url,
                css: imageStyles,
                alt: offer.offerCode
              })]
            }) : _jsx("span", {
              css: imageStyles
            })
          }), _jsxs(Typography, {
            type: "Body1",
            color: "night_rider",
            className: "text-center whitespace-normal ".concat(props.context.isMobileView ? "pt-2" : "pt-2"),
            semi_bold: true,
            children: [(_offer$v2Details = offer.v2Details) === null || _offer$v2Details === void 0 ? void 0 : _offer$v2Details.discountPercent, "% OFF"]
          })]
        }, offer.offerCode);
      }), props.catalogues.map(function (catalogue) {
        var displayImage = getDisplayImageObj(catalogue.images[0], props.context.isMobileView ? "1" : "2");
        return _jsxs("div", {
          css: gridItemContainer,
          onClick: function onClick() {
            return onCatalogueClick(catalogue);
          },
          children: [_jsx("div", {
            css: imageContainerStyles,
            children: displayImage.url ? _jsxs("picture", {
              children: [_jsx("source", {
                srcSet: displayImage.webP,
                type: "image/webp"
              }), _jsx("img", {
                src: displayImage.url,
                css: imageStyles,
                alt: catalogue.name
              })]
            }) : _jsx("span", {
              css: imageStyles
            })
          }), _jsx(Typography, {
            type: "Body1",
            color: "night_rider",
            className: "text-center whitespace-normal ".concat(props.context.isMobileView ? "pt-2" : "pt-2"),
            semi_bold: true,
            children: catalogue.name
          })]
        }, catalogue._id);
      })]
    })
  });
}
export default ShopCatalogueBubbles;